function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-919.000000, -1295.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Time_Passing_No_Hands",
  transform: "translate(919.000000, 1295.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.858815,56 C8.858815,29.96483 29.964585,8.85906 55.999755,8.85906 C82.035415,8.85906 103.141185,29.96483 103.141185,56 C103.141185,82.03517 82.035415,103.14094 55.999755,103.14094 C29.964585,103.14094 8.858815,82.03517 8.858815,56",
  id: "Fill-1",
  fill: "#E8E6EE"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "#968FAD",
  points: "51.64831 21.18795 60.3512 21.18795 60.3512 5.95728 51.64831 5.95728"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  fill: "#968FAD",
  points: "51.64831 21.18795 60.3512 21.18795 60.3512 5.95777 51.64831 5.95777"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#968FAD",
  points: "5.95777 60.3512 21.18795 60.3512 21.18795 51.64831 5.95777 51.64831"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-7",
  fill: "#968FAD",
  points: "5.95777 60.3512 21.18795 60.3512 21.18795 51.64831 5.95777 51.64831"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  fill: "#968FAD",
  points: "90.81205 60.3512 106.04223 60.3512 106.04223 51.64831 90.81205 51.64831"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#968FAD",
  points: "90.81205 60.3512 106.04223 60.3512 106.04223 51.64831 90.81205 51.64831"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#968FAD",
  points: "51.64831 106.18678 60.3512 106.18678 60.3512 90.9566 51.64831 90.9566"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  fill: "#968FAD",
  points: "51.64831 106.18727 60.3512 106.18727 60.3512 90.9566 51.64831 90.9566"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.000245,0.52759 C25.363485,0.52759 0.527835,25.36324 0.527835,56 C0.527835,86.63676 25.363485,111.47241 56.000245,111.47241 C86.636515,111.47241 111.472165,86.63676 111.472165,56 C111.472165,25.36324 86.636515,0.52759 56.000245,0.52759 M56.000245,11.59081 C80.487505,11.59081 100.409435,31.51274 100.409435,56 C100.409435,80.48726 80.487505,100.40919 56.000245,100.40919 C31.512495,100.40919 11.590565,80.48726 11.590565,56 C11.590565,31.51274 31.512495,11.59081 56.000245,11.59081",
  id: "Fill-12",
  fill: "#5F5984"
}))));

var SvgTimePassingNoHands = function SvgTimePassingNoHands(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "112px",
    viewBox: "0 0 112 112",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimePassingNoHands, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time-passing-no-hands.c8937074.svg";
export { ForwardRef as ReactComponent };